<template>
  <div v-if="loading === 'idle'">
    <div class="w-full">
      <vx-card>
        <vs-table
          no-data-text="У вас нет ни одного виджета. Создайте новый виджет, чтобы получить доступ к функционалу сервиса."
          search
          stripe
          :data="widgets">
          <template slot="header">
            <vs-button :to="{name: 'widgets_add'}" v-can="'widget.manage'">Создать виджет</vs-button>
          </template>
          <template slot="thead">
            <vs-th sort-key="id">
              ID
            </vs-th>
            <vs-th sort-key="title">
              Название виджета
            </vs-th>
            <vs-th sort-key="whatsapp">
              <div class="text-center w-full">
                Включен
              </div>
            </vs-th>
            <vs-th sort-key="actions" v-can="'widget.manage'">
              Действия
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr @click.native="$router.push({ name: 'widgets_edit', params: { widgetSlug: data[indextr].slug } })" :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
              <vs-td :data="data[indextr].id">
                {{ data[indextr].slug }}
              </vs-td>

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td>
                <div class="text-center">
                  <vs-icon v-if="data[indextr].enabled" icon="done" size="small" color="success"></vs-icon>
                  <vs-icon v-else icon="clear" size="small" color="danger"></vs-icon>
                </div>
              </vs-td>

              <vs-td :data="data[indextr].actions" v-can="'widget.manage'">
                <div class="flex items-center justify-end">
                  <vs-dropdown
                      vs-trigger-click
                      @click.native.stop
                  >
                      <vs-button
                        type="flat"
                        size="large"
                        icon-pack="feather"
                        icon="icon-minimize"
                      />

                      <vs-dropdown-menu>
                        <div class="dropdown-custom dropdown-custom--full">
                          <div class="mb-6">
                            <h6 class="mb-2">Widget script</h6>
                            <div class="flex items-center">
                              <vs-textarea
                                class="m-0 mr-4 w-full"
                                rows="4"
                                ref="widget_script"
                                :value="data[indextr].script"
                                readonly
                              />
                              <vs-button
                                icon-pack="feather"
                                type="flat"
                                size="medium"
                                icon="icon-copy"
                                @click.prevent="handleClickCopy(data[indextr].script)"
                              />
                            </div>
                          </div>
                        </div>
                      </vs-dropdown-menu>
                  </vs-dropdown>
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-edit"
                    @click.native.stop
                    :to="{name: 'widgets_edit', params: {widgetSlug: data[indextr].slug}}"></vs-button>
                  <vs-button
                    type="flat"
                    size="large"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    @click.prevent.stop="handleWidgetDelete(data[indextr])"></vs-button>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import copyToClipboard from '@/mixins/copyToClipboard'

export default {
  mixins: [copyToClipboard],
  computed: {
    ...mapGetters(['authUserCompany']),
    ...mapState('Widgets', ['widgets', 'loading'])
  },
  async created () {
    await this.fetchWidgets()
  },
  methods: {
    ...mapActions('Widgets', ['removeWidget', 'fetchWidgets']),
    handleWidgetDelete (widget) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Вы действительно хотите удалить виджет «${widget.name}» из Yolker?`,
        text: `Виджет «${widget.name}» будет удален из системы.`,
        accept: () => this.deleteWidget(widget),
        acceptText: 'Да, хочу',
        cancelText: 'Нет'
      })
    },
    async deleteWidget (widget) {
      const { status } = await this.removeWidget(widget.slug)

      if (status === 'success') {
        this.$vs.notify({
          color: 'success',
          title: 'Удаление прошло успешно',
          text: `Виджет «‎‎${widget.name}» был удалена из системы`
        })
      } else {
        this.$vs.notify({
          color: 'danger',
          title: 'Произошла ошибка',
          text: ''
        })
      }
    },
    async handleClickCopy (text) {
      const copied = await this.copyTextToClipboard(text)
      if (copied) {
        this.$vs.notify({
          color: 'success',
          title: 'Cкопировано в буфер обмена',
          text: ''
        })
      }
    }
  }
}
</script>
